export const OPTANON_CONSENT_COOKIES = "OptanonConsent";
export const OPTANON_ALERT_BOX_CLOSED = "OptanonAlertBoxClosed";
